import Index from '../../views/sims/Index.vue';

export default [
  {
    path: '/sims',
    name: 'sims',
    component: Index,
    meta: {
      can: 'view sim',
      breadcrumb: [
        { name: 'SIM卡庫存', route: "sims" }
      ]
    }
  },
]
